import { TFunction } from "i18next"
import { Grid, Menu } from "react-feather"

export const switchButtons = (t: TFunction) => [
  {
    Icon: Menu,
    id: "LIST",
    tooltip: t("inventario.articulos.list"),
  },
  {
    Icon: Grid,
    id: "GRID",
    tooltip: t("inventario.articulos.grid"),
  },
]
